import TerminalIcon from "@mui/icons-material/Terminal";
import {
  ClaudeIcon,
  CodexIcon,
  CursorIcon,
  GeminiCliIcon,
} from "@/components/integrations/BrandIcons";
import { CLAUDE_BRAND_COLOR, type KnownApp } from "./knownApps";

/**
 * The mark of a client we recognise, at `fontSize`. Claude and Gemini CLI
 * keep their brand colours in both modes; the monochrome marks follow the
 * text colour, and the CLI's terminal the neutral one.
 */
export default function KnownAppMark({
  app,
  fontSize,
}: {
  app: KnownApp;
  fontSize: number;
}) {
  switch (app) {
    case "claude":
      return <ClaudeIcon sx={{ fontSize, color: CLAUDE_BRAND_COLOR }} />;
    case "cursor":
      return <CursorIcon sx={{ fontSize, color: "text.primary" }} />;
    case "gemini-cli":
      return <GeminiCliIcon sx={{ fontSize }} />;
    case "codex":
      return <CodexIcon sx={{ fontSize, color: "text.primary" }} />;
    case "webshare-cli":
      return <TerminalIcon sx={{ fontSize, color: "neutral.main" }} />;
  }
}
